import { getRequestContext } from '../context';
import {
    B2B_DOMAIN_LOCAL,
    B2B_DOMAIN_YCP_DEV,
    B2B_DOMAIN_YCP_PRODUCTION,
    B2B_DOMAIN_YCP_SANDBOX,
    B2B_DOMAIN_YCP_TEST,
    B2B_URL_LOCAL,
} from './const';

/**
 * Возвращает hostname кабинета на checkout.merchants.yandex.ru в зависимости от текущего окружения.
 *
 * @kind helper
 * @returns Hostname для текущего окружения
 */
export const getKitLiteDomainByEnv = (): string => {
    const { env, isSandbox } = getRequestContext();

    if (__IS_DEV__) {
        return B2B_DOMAIN_LOCAL;
    }

    if (isSandbox) {
        return B2B_DOMAIN_YCP_SANDBOX;
    }

    switch (env) {
        case 'prestable':
            return B2B_DOMAIN_YCP_TEST;

        case 'development':
            return B2B_DOMAIN_YCP_DEV;

        case 'production':
            return B2B_DOMAIN_YCP_PRODUCTION;

        default:
            return B2B_DOMAIN_YCP_PRODUCTION;
    }
};

/**
 * Возвращает базовый URL кабинета на checkout.merchants.yandex.ru в зависимости от текущего окружения.
 *
 * @param path - опциональный путь для добавления к базовому URL
 * @returns Полный URL для текущего окружения
 * @kind helper
 */
export const getKitLiteUrlByEnv = (path: string = ''): string => {
    if (__IS_DEV__) {
        return `${B2B_URL_LOCAL}${path}`;
    }

    return `https://${getKitLiteDomainByEnv()}${path}`;
};
